import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const xray = {
    jpath: ['spectra', 'xray'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xray;
//# sourceMappingURL=xray.js.map